import { horizontalRace } from "../options/horizontal-race";
import { vertical } from "../options/vertical";
import { lengthDataHandler } from "./get-length";
import { groupArrays } from "./group-arrays";

type TProps = {
  primaryColor?: string;
  colors: string[];
  type: "horizontal-race" | "vertical-race";
  data: Record<string, string>[][];
  payload: Record<string, unknown>;
};

export const raceData = ({
  data,
  colors,
  primaryColor,
  type,
  payload,
}: TProps) => {
  const [seriesTitles, ...restData] = data;
  seriesTitles.shift();
  const grouped = groupArrays(
    restData.map((row) => row.filter((cell) => !!cell?.value)),
  );
  let [axisTitles = [], ...gropedData] = grouped;
  const titles = axisTitles.map((cell) => cell?.value ?? "");

  if (type === "horizontal-race") {
    titles.reverse();
    gropedData = gropedData.map((arr) => arr.reverse());

    if (gropedData.length === 1) {
      colors = colors.splice(0, gropedData[0].length);
      if (colors.length < gropedData[0].length) {
        colors = colors.concat(
          Array(gropedData[0].length - colors.length).fill(primaryColor),
        );
      }
      colors.reverse();
    }
  }

  let series = gropedData.map((arr, i) => {
    const mapped = arr.map((cell) => cell?.value ?? 0);
    return {
      data: mapped,
      realtimeSort: true,
      type: "bar",
      itemStyle: { color: colors[i] ?? primaryColor },
      name: seriesTitles[i]?.value ?? "",
      // universalTransition: true,
      animationDurationUpdate: 1000,
    };
  });

  if (series.length === 1) {
    const seriesData = series[0].data.map((value, index) => ({
      value,
      itemStyle: { color: colors[index] ?? primaryColor },
    }));
    series = [
      {
        realtimeSort: true,
        data: seriesData,
        type: "bar",
        name: seriesTitles[0]?.value ?? "",
        // universalTransition: true,
        animationDurationUpdate: 1000,
      },
    ] as any[];
  }

  return {
    option:
      type === "horizontal-race"
        ? horizontalRace(payload, { titles, series })
        : vertical(payload, { titles, series }),
    ...lengthDataHandler(titles, series),
  };
};
